import { render, staticRenderFns } from "./InvestorReceivablePaymentsFilter.vue?vue&type=template&id=514823c7&"
import script from "./InvestorReceivablePaymentsFilter.vue?vue&type=script&lang=js&"
export * from "./InvestorReceivablePaymentsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports